export const DeleteContactModal: string = 'DeleteContactModal';
